<template>
  <div class="course-list">
    <div class="course-head" @click="$emit('back')">
      <a-icon style="font-size: 20px" type="left" />
      <span>{{ coursePackage.name }}</span>
    </div>
    <a-spin :spinning="tableRelevant.tableLoading">
      <div class="course-table list" :class="{ jcenter: !tableRelevant.tableDataSource.length }">
        <RourceItem
          v-for="item in tableRelevant.tableDataSource"
          :type="2"
          :packageCourse="true"
          :showAction="false"
          class="item"
          :key="item.id"
          :detail="item"
          @click.native="goCourseHourResource(item)"
          :roundCount="$route.query.tabActive == 1"
        ></RourceItem>
        <a-empty v-if="!tableRelevant.tableDataSource.length" description="暂无数据" />
      </div>
      <div v-if="tableRelevant.tablePagination.total > 0" style="width: 100%; overflow: hidden">
        <a-pagination
          :showTotal="tableRelevant.tablePagination.showTotal"
          :total="tableRelevant.tablePagination.total"
          :pageSize="tableRelevant.tablePagination.pageSize"
          :page-size-options="['10', '20', '30']"
          show-size-changer
          show-quick-jumper
          :current="tableRelevant.tablePagination.current"
          @change="tableRelevant.tablePagination.onChange"
          @showSizeChange="tableRelevant.tablePagination.onShowSizeChange"
          style="float: right"
        />
      </div>
    </a-spin>
  </div>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import RourceItem from '@/components/RourceItem'
export default {
  name: '',
  components: { RourceItem },
  props: {
    coursePackage: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tableRelevant: tableRelevant.call(this),
    }
  },
  mounted() {
    this.getPageList(1)
  },
  methods: {
    getPageList(pageIndex) {
      const params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        OrganizationCourseResourcePackageId: this.coursePackage.id,
      }
      this.tableRelevant.tableLoading = true
      this.$http.CourseService.getCourseListByPackage(params).then((res) => {
        this.tableRelevant.tableLoading = false
        const { data, status, message } = res
        this.tableRelevant.tableDataSource = data.items.map((v) => {
          v.name = v.courseResourceName
          // v.isLimitCount = v.isLimitUser
          // v.maxCount = v.maxUserCount
          // v.usedCount = v.configUserCount
          return v
        })
        this.tableRelevant.tablePagination.total = data.totalCount
        this.tableRelevant.tablePagination.current = data.pageIndex
      })
    },
    goCourseHourResource(item) {
      this.$store.commit('organization/setCourseHourResource', item)
      this.$router.push({
        path: `/projectImpl/pMechanism/orgDetails/courseHour`,
        query: {
          id: item.id,
          fullPath: window.encodeURIComponent(this.$route.fullPath),
          name: item.courseName,
          reportFrequency: item.reportFrequency,
        },
      })
    },
  },
}
</script>
<style lang="less" scoped>
.course-list {
  padding: 0 24px;
  .course-head {
    display: flex;
    cursor: pointer;
    font-size: 18px;
    align-items: center;
  }
}
.list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
  column-gap: calc((100% - 380px * 3) / 3);

  .item {
    margin-left: 20px;
  }
}

.jcenter {
  justify-content: center;
}
</style>
